/**
 * Cloudflare R2 buckets — shared types.
 *
 * Multiple buckets share one set of Cloudflare credentials (account ID +
 * access keys). Each bucket carries a purpose tag so the admin UI + feature
 * pickers can filter by intent.
 */
export const R2_BUCKET_PURPOSES = [
    'media',
    'backup',
    'agent_uploads',
    'other',
];
export const R2_BUCKET_PURPOSE_LABELS = {
    media: 'Media',
    backup: 'Backup',
    agent_uploads: 'Agent uploads',
    other: 'Other',
};
//# sourceMappingURL=r2-buckets.js.map